(function () {
  'use strict';

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  let debounceTimer = null;
  const DEBOUNCE_MS = 80;

  let isFetching = false;

  async function refreshCartDrawer() {
    if (isFetching) return;

    const cartDrawer = getCartDrawer();
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return;

    isFetching = true;

    try {
      const sections = cartDrawer.getSectionsToRender().map(s => s.id);

      const url = `${window.Shopify?.routes?.root ?? '/'}cart?sections=${sections.join(',')}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) return;

      const data = await response.json();

      const parsedState = {
        sections: data,
        openCartDrawer: false,
        id: null,
      };

      cartDrawer.renderContents(parsedState);
    } catch (err) {
      if (window.Shopify?.designMode) {
        console.warn('[rebuy-cart-bridge] Refresh failed:', err);
      }
    } finally {
      isFetching = false;
    }
  }

  function handleRebuyCartChange() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refreshCartDrawer, DEBOUNCE_MS);
  }

 
  if (!window.__rebuyCartBridgeInit) {
    window.__rebuyCartBridgeInit = true;
    document.addEventListener('rebuy:cart.change', handleRebuyCartChange);
  }
})();